/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="59.54"
        height="95.46"
        viewBox="0 0 59.54 95.46"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M29.77 0A29.77 29.77 0 1 0 59.5 29.77 29.77 29.77 0 0 0 29.77 0Zm0 2.5A27.27 27.27 0 1 1 2.5 29.77 27.27 27.27 0 0 1 29.77 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m42.06 18.93 2.13 2.12-17.1 17.1-10.74-10.73 2.12-2.13 8.62 8.62 14.97-14.98z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M48.66 50.5a1.24 1.24 0 0 1 1.29 1.07v.13l1.7 42.48a1.25 1.25 0 0 1-1.82 1.16l-.1-.06-20-12.8-20 12.8a1.26 1.26 0 0 1-1.93-1v-.12l1.7-42.48a1.25 1.25 0 0 1 2.5 0v.13l-1.5 40.05 18.62-11.93a1.26 1.26 0 0 1 1.23-.07l.12.07L49.1 91.86l-1.6-40.08a1.24 1.24 0 0 1 1-1.28Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'RibbonWithCheckmarkIcon';

export default Icon;
